import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from "react";
import { Link } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import ModalDeposito from "./Fichas/ModalFichaFactura/ModalDeposito";
import { COLUMNS2 } from "./Columns";
import { GlobalFilter } from "./GlobalFilter";
//import './table.css';
import "./filtering.css";
import { getAllFacturacion } from "../../../Api/facturacion";
import { getAdminCredentials, getAdminById } from "../../../Api/AdminApi";
import { updateFactura } from "../../../Api/facturacion";
import { getAllFormaPago } from "../../../Api/formaPago"
import { TailSpin } from 'react-loader-spinner'
import Swal from "sweetalert2";
const Facturas = () => {
  const [userData, setUserData] = useState({});
  const [showDeposito, setShowDeposito] = useState(false);
  const [idFacturaDeposito, setIdFacturaDeposito] = useState(null);
  const [listFormadepago, setListFormadepago] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState([]);
  const columns = useMemo(() => COLUMNS2, []);
  const assigmentValue = useCallback(async () => {
    try {

      const resultUser = await getAdminCredentials();
      const datauser = await getAdminById(resultUser.IdUsuario);
      setUserData(datauser[0]);
      const result = await getAllFacturacion();
      let resultfiltro = result
      if (datauser[0].ventas_montos === "false") {
        resultfiltro = result.map(item => ({
          ...item,
          totalFactura: ""
        }));
      }
      const listResut3 = await getAllFormaPago()
      const resultMapeado = listResut3.map((item) => {
        return { label: item.nombre, value: item.nombre };
      });
      let resulting = resultMapeado.filter(item => item.label != "Efectivo")
      const resultWithActions = resultfiltro.map(item => ({
        ...item,
        openDeposito
      }));

      setdata(resultWithActions);

      setListFormadepago(resulting);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  });
  useEffect(() => {
    assigmentValue();
  }, []);
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },

    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  const openDeposito = (idFactura) => {
    setIdFacturaDeposito(idFactura);
    setShowDeposito(true);
  };

  const closeDeposito = () => {
    setShowDeposito(false);
    setIdFacturaDeposito(null);
  };



  const onReturnDeposito = async (data1, data2, data3) => {
    try {
      const result = await updateFactura(data1);
      const result2 = await updateFactura(data2);
      const result3 = await updateFactura(data3);

      if (result && result2 && result3) {
        Swal.fire({
          title: "Depósito Realizado",
          text: "Actualizado correctamente",
          icon: "success",
        });

        closeDeposito(); // 👈 cerrar modal
        assigmentValue(); // 👈 refrescar tabla
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${err}`,
      });
    }
  };


  return (
    <Fragment>
      <div className="col-md-12">
        <div className="card">
          <div className="card-body pb-0">
            <div className="row justify-content-between">
              <div className="col-auto">
                <Card.Title>Facturas</Card.Title>
              </div>
              <div className="col-auto">
                <h5>

                  <Button>
                    <Link to="/generarfactura" style={{ color: "white" }}>
                      Generar Factura
                    </Link>
                  </Button>


                </h5>
              </div>
            </div>
          </div>
          <div className="chart-wrapper">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <GlobalFilter
                    filter={globalFilter}
                    setFilter={setGlobalFilter}
                  />
                  <TailSpin
                    height="30"
                    width="30"
                    color="Black"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={loading}
                  />
                  <br></br>
                  <table
                    {...getTableProps()}
                    className="table dataTable display"
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th {...column.getHeaderProps()}>
                              {column.render("Header")}
                              {column.canFilter
                                ? column.render("Filter")
                                : null}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => (
                              <td {...cell.getCellProps()}>
                                <Link to={`/FichaFactura/${row.values.idFactura}`}>
                                  {cell.render("Cell")}
                                </Link>
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>


                  </table>
                  <div className="d-flex justify-content-between">
                    <span>
                      Página{" "}
                      <strong>
                        {pageIndex + 1} de {pageOptions.length}
                      </strong>
                      {""}
                    </span>
                    <span className="table-index">
                      Ir a la página :{" "}
                      <input
                        type="number"
                        className="ml-2"
                        defaultValue={pageIndex + 1}
                        onChange={(e) => {
                          const pageNumber = e.target.value
                            ? Number(e.target.value) - 1
                            : 0;
                          gotoPage(pageNumber);
                        }}
                      />
                    </span>
                  </div>
                  <div className="text-center mb-3">
                    <div className="filter-pagination  mt-3">
                      <button
                        className=" previous-button"
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                      >
                        {"<<"}
                      </button>

                      <button
                        className="previous-button"
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                      >
                        Anterior
                      </button>
                      <button
                        className="next-button"
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                      >
                        Siguiente
                      </button>
                      <button
                        className=" next-button"
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                      >
                        {">>"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalDeposito
        estado={showDeposito}
        onCloseModal={closeDeposito}
        onReturnValue={onReturnDeposito}
        listFormadepago={listFormadepago}
        id={idFacturaDeposito}
      />
    </Fragment>

  );
};
export default Facturas;
